import {initWebComponent} from "@/helpers/web-component-helper";
import {initLocationSearch} from "@/helpers/location-search-helper";
import {initGeoLocation} from "@/helpers/ol-geo-location-helper";
import {transformExtent} from "ol/proj";

const template = document.createElement('template');

export class FormGeoLocationComponent extends HTMLElement {
    constructor() {
        super();
        const name = this.getAttribute('data-name')
        const placeholder = this.getAttribute('data-placeholder')
        const height = this.getAttribute('data-height')
        const attributeID = this.getAttribute('data-attribute-id')

        window.geoLocationAttributeID = attributeID

        template.innerHTML = `
       <div class="row">
            <div class="col-12 col-md-6 text-primary">
                <div class="form-group">
                    <h2>` + name + `</h2>
                    <div class="input-group mt-2">
                        <input type="text" id="iptNewNotificationLocation" class="form-control" placeholder="` + placeholder + `">
                        <span class="input-group-append">
                            <button class="btn btn-default icon-btn" id="btnGetCurrentPosition" type="button"><span class="fa fa-map-marker-alt"></span></button>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <h2 class="text-primary">&nbsp;</h2>
                    <div class="input-group mt-2">
                        <span id="selectedItem"></span>
                    </div>
                </div>
            </div>      
        </div>
        <div class="row">
            <div class="col">
                <div id="divLegendImage">
                    <div class="card" id="divLegend">
                      <div class="card-header p-1" id="headingOne">
                        <a href="#" id="aLinkLegendGraphic" class="text-secondary d-flex justify-content-between text-body text-decoration-none" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          Legenda
                          <div class="collapse-icon ml-2"></div>
                        </a>
                      </div>
                      <div id="collapseOne" class="card-body accordion-collapse p-2 collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample" style="">
                        <select size="1" class="form-control" id="slcMapStyleSelector" style="display: none"><option></option></select>
                        <div>
                          <img id="legend" src="">
                        </div>
                      </div>
                    </div>
                    <div class="card mt-1" id="divLegendLinked">
                      <div class="card-header p-1" id="headingOne">
                        <a href="#" id="aLinkLegendGraphic" class="text-secondary d-flex justify-content-between text-body text-decoration-none" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          Legenda
                          <div class="collapse-icon ml-2"></div>
                        </a>
                      </div>
                      <div id="collapseOne" class="card-body accordion-collapse p-2 collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample" style="">
                        <select size="1" class="form-control" id="slcMapStyleSelector" style="display: none"><option></option></select>
                        <div>
                          <img id="legendLinked" src="">
                        </div>
                      </div>
                    </div>
                  </div>
                  <nav class="layout-footer layout-footer-map footer bg-transparent">
                    <div class="container-fluid d-flex flex-wrap justify-content-between text-center container-p-x pb-3">
                      <div class="pt-md-3">
                        <ol-zoom-in></ol-zoom-in>
                        <ol-zoom-out></ol-zoom-out>
                      </div>
                    </div>
                  </nav>
                <ol-map style="width: 100%;display: block;height:` + height + `;min-height: 33vh;"></ol-map>
<!--                <ol-map style="height: calc(100vh - 800px);width: 100%;display: block;"></ol-map>-->
           </div>
        </div>`

        initWebComponent(this, template)

        initLocationSearch(document.getElementById('iptNewNotificationLocation'))
        initGeoLocation(document.getElementById('btnGetCurrentPosition'))
    }
}
